import { m } from "framer-motion";
import { useState } from "react";
import cn from "classnames";
import ChevronDown from "./icons/chevron-down";
const DropDown = ({ onClick, dropDownData, variant = "normal" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState("Select One");
  const ValueSetter = (option, e) => {
    setValue(option);
    onClick(option);
    setIsOpen(false);
  };
  return (
    <div
      className={cn(
        {
          "md:w-44 w-36": variant === "normal",
          "md:w-52 w-40": variant === "wide",
        },
        "landing-drop md:top-1 top-1.5 right-1.5 flex z-10 flex-col bg-[#e9e7de] absolute rounded-[30px] items-center justify-center text-center transition-all duration-300 ease group cursor-pointer "
      )}
      onClick={() => setIsOpen(!isOpen)}
    >
      <div
        className={
          "landing-select w-full flex justify-center items-center py-3 mx-auto cursor-pointer transition-all duration-300 ease text-center "
        }
      >
        <p
          className={cn(
            "h-full text-darkGrey/80 md:text-sm text-xs text-center mb-0 font-semibold transition-all duration-500 ease transform "
          )}
        >
          {value}
        </p>
        <ChevronDown
          className={cn(
            {
              "-rotate-180": isOpen,
              "rotate-0": !isOpen,
            },
            "right-2 absolute transition-all duration-300 ease text-darkGrey/50"
          )}
        />
      </div>
      {/* <AnimatePresence>
                  {isOpen && ( */}
      <m.div
        animate={isOpen ? "open" : "closed"}
        initial={{ height: 0, opacity: 0 }}
        variants={{
          closed: { height: 0, opacity: 0 },
          open: { height: "auto", opacity: 100 },
        }}
        transition={{ duration: 0.3 }}
        className={`flex flex-col w-full relative bg-inherit overflow-hidden justify-center rounded-b-[30px] border-t-[0.5px] last:border-b-0 px-4 ${
          !isOpen ? "border-transparent" : "border-darkGrey/50 shadow-dropdown"
        }`}
      >
        {dropDownData?.map((row, key) => (
          <m.div
            animate={isOpen ? "open" : "closed"}
            // variants={{ closed: { opacity: 0 }, open: { opacity: 1 } }}
            transition={{ duration: 0.3 }}
            className="w-full flex items-center justify-center py-2 text-darkGrey md:text-sm text-xs leading-tight text-center border-b-[0.5px] border-darkGrey/50 last:border-0"
            key={"sectorCategory" + key}
            onClick={(e) => ValueSetter(row, e)}
          >
            {row}
          </m.div>
        ))}
      </m.div>
      {/* )}
              </AnimatePresence> */}
    </div>
  );
};

export default DropDown;
